import loginReducer from './login/loginReducer';
import navigationReducer from './navigation/navigationReducer';
import reserveReducer from './reserve/reserveReducer';
import searchReducer from './search/searchReducer';
import tokenReducer from './token/tokenReducer';

export default {
  login: loginReducer,
  navigation: navigationReducer,
  reserve: reserveReducer,
  search: searchReducer,
  token: tokenReducer
};
